import MangaNavbar from "@/components/feature/MangaNavbar";
import MangaFooter from "@/components/feature/MangaFooter";
import BackToTop from "@/components/feature/BackToTop";
import JsonLd from "@/components/feature/JsonLd";
import { useSeo } from "@/hooks/useSeo";
import Hero from "./components/Hero";
import UpdatesSection from "./components/UpdatesSection";
import PopularSection from "./components/PopularSection";
import GenresSection from "./components/GenresSection";
import SpotlightSection from "./components/SpotlightSection";
import FaqPreview from "./components/FaqPreview";

export default function Home() {
  useSeo({
    title: "天天漫画网 - 每日更新海量人气连载漫画，今日最新话抢先看",
    description:
      "天天漫画网每日更新海量人气连载漫画，今日最新话抢先看！追更不迷路，热门日漫、国漫持续上线，打开即享最新剧情，告别漫长等待。",
    keywords: "天天漫画网,漫画每日更新,追更漫画,今日更新,连载漫画,日漫,国漫",
    canonicalPath: "/",
  });

  const orgData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "天天漫画网",
    url: "https://panelpeek.github.io/",
    description:
      "天天漫画网每日更新海量人气连载漫画，今日最新话抢先看，支持追更、收藏与更新提醒。",
  };

  const siteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "天天漫画网",
    url: "https://panelpeek.github.io/",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://panelpeek.github.io/latest?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <JsonLd id="org-jsonld" data={orgData} />
      <JsonLd id="website-jsonld" data={siteData} />
      <MangaNavbar />
      <main>
        <Hero />
        <UpdatesSection />
        <PopularSection />
        <GenresSection />
        <SpotlightSection />
        <FaqPreview />
      </main>
      <MangaFooter />
      <BackToTop />
    </>
  );
}